import { datadogRum } from '@datadog/browser-rum'
import environment from '../../../config'

export const loadDatadogRumScript = (): void => {
  if (!environment.rum.enabled) return

  try {
    datadogRum.init({
      applicationId: environment.rum.applicationId,
      clientToken: environment.rum.clientToken,
      service: environment.rum.service,
      env: environment.rum.env,
      sessionSampleRate: 100, // If we disable this, error tracking will stop to work
      sessionReplaySampleRate: 0,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      telemetrySampleRate: 0,
      telemetryConfigurationSampleRate: 0,
      traceSampleRate: 100, // We want all requests to our APIs to be traced
      allowedTracingUrls: [/https:\/\/apim(-dev)?\.ambevdevs\.com\.br/],
      defaultPrivacyLevel: 'allow',
      trackingConsent: 'granted',
      sessionPersistence: 'local-storage',
    })

    if (environment.debugEnabled) console.log('[RUM] Script loaded successfully.')
  } catch (err) {
    console.error('[RUM] Could not load script.')
  }
}

export const registerError = (error: Error, data?: object): void =>
  environment.rum.enabled ? datadogRum.addError(error, data) : console.error(error, data)
